<div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="treatment-endo-edit-row-dialog-container">
  <div class="section-header" style="flex-basis: 30px;" data-cy="treatment-endo-edit-row-dialog-header">
    <div class="section-header-title" data-cy="treatment-endo-edit-row-dialog-title">
      Canal Detail - Tooth# {{getDocumentFormToothNumber()}} - {{getCanalType()}}
    </div>
    <div style="flex: 1;"></div>
    <div style="flex-basis: fit-content; cursor: pointer; margin-right: 15px; margin-top: 3px;" data-cy="treatment-endo-edit-row-dialog-filter-container"><mat-checkbox labelPosition="before" [checked]="this.isTreatmentEwlAwlFilter" (change)="onFilterByLenght($event)" data-cy="treatment-endo-edit-row-dialog-filter-checkbox"> EWL/AWL Increment by 0.50</mat-checkbox></div>
  </div>
  @if (isLoading) {
    <app-tdo-progress-spinner style="flex: 1;" data-cy="treatment-endo-edit-row-dialog-progress-spinner"></app-tdo-progress-spinner>
  }
  @if (!isLoading) {
    <div class="section-content" style="display: flex; flex: 1; overflow-y: hidden;" data-cy="treatment-endo-edit-row-dialog-content">
      <!--    Pulp Status-->
      <div class="canal-column" data-cy="treatment-endo-edit-row-dialog-pulp-status-column">
        <div class="canal-row-header-item" data-cy="treatment-endo-edit-row-dialog-pulp-status-header">Pulp Status</div>
        <div class="canal-list" data-cy="treatment-endo-edit-row-dialog-pulp-status-list">
          @for (enu of enumService.pulpStatusEnums; track enu; let i = $index) {
            <div class="canal-list-item"
              (click)="onItemClick(enu, 'enumEndoPulpStatusID')"
              (contextmenu)="onRightMouseClick($event, enumService.pulpStatusEnums, 'pulpStatusEnums')"
              [ngClass]="{'selected': isSelectedItem(enu, 'enumEndoPulpStatusID')}"
              data-cy="treatment-endo-edit-row-dialog-pulp-status-item-{{i}}">
              {{enu.ItemDisplayValue}}
            </div>
          }
        </div>
      </div>
      <!--    Estimated Work Length-->
      <div class="canal-column" style="flex: 1;" data-cy="treatment-endo-edit-row-dialog-ewl-column">
        <div class="canal-row-header-item" style="flex-basis: 40px; padding-top: 4px;" data-cy="treatment-endo-edit-row-dialog-ewl-header">Est Work Length</div>
        <div class="canal-master-list" data-cy="treatment-endo-edit-row-dialog-ewl-master-list">
          @for (list of estimatedWorkLengthEnumsArray; track list; let i = $index) {
            <div class="canal-list" data-cy="treatment-endo-edit-row-dialog-ewl-list-{{i}}">
              @for (enu of list; track enu; let itemIndex = $index) {
                <div class="canal-list-item"
                  (click)="onItemClick(enu, 'enumEndoEstimatedWorkLengthID')"
                  [ngClass]="{'selected': isSelectedItem(enu, 'enumEndoEstimatedWorkLengthID')}"
                  (contextmenu)="onRightMouseClick($event, enumService.estimatedWorkLengthEnums, 'estimatedWorkLengthEnums')"
                  data-cy="treatment-endo-edit-row-dialog-ewl-list-{{i}}-item-{{itemIndex}}">
                  {{enu.ItemDisplayValue}}
                </div>
              }
            </div>
          }
        </div>
      </div>
      <!--    Reference-->
      <div class="canal-column" data-cy="treatment-endo-edit-row-dialog-reference-column">
        <div class="canal-row-header-item" data-cy="treatment-endo-edit-row-dialog-reference-header">Reference</div>
        <div class="canal-list" data-cy="treatment-endo-edit-row-dialog-reference-list">
          @for (enu of enumService.referenceEnums; track enu; let i = $index) {
            <div class="canal-list-item"
              (click)="onItemClick(enu, 'enumEndoReferenceID')"
              (contextmenu)="onRightMouseClick($event, enumService.referenceEnums, 'referenceEnums')"
              [ngClass]="{'selected': isSelectedItem(enu, 'enumEndoReferenceID')}"
              data-cy="treatment-endo-edit-row-dialog-reference-item-{{i}}">
              {{enu.ItemDisplayValue}}
            </div>
          }
        </div>
      </div>
      <!--    Actual Work Length-->
      <div class="canal-column" style="flex: 1;" data-cy="treatment-endo-edit-row-dialog-awl-column">
        <div class="canal-row-header-item" style="flex-basis: 40px; padding-top: 4px;" data-cy="treatment-endo-edit-row-dialog-awl-header">Actual Work Length</div>
        <div class="canal-master-list" data-cy="treatment-endo-edit-row-dialog-awl-master-list">
          @for (list of estimatedWorkLengthEnumsArray; track list; let i = $index) {
            <div class="canal-list" data-cy="treatment-endo-edit-row-dialog-awl-list-{{i}}">
              @for (enu of list; track enu; let itemIndex = $index) {
                <div class="canal-list-item"
                  (click)="onItemClick(enu, 'enumEndoActualWorkLengthID')"
                  (contextmenu)="onRightMouseClick($event, enumService.estimatedWorkLengthEnums, 'estimatedWorkLengthEnums')"
                  [ngClass]="{'selected': isSelectedItem(enu, 'enumEndoActualWorkLengthID')}"
                  data-cy="treatment-endo-edit-row-dialog-awl-list-{{i}}-item-{{itemIndex}}">
                  {{enu.ItemDisplayValue}}
                </div>
              }
            </div>
          }
        </div>
      </div>
      <!--    Apical Curvature-->
      <div class="canal-column" style="flex: 1; background-color: unset; padding-bottom: unset;" data-cy="treatment-endo-edit-row-dialog-apical-curvature-column">
        <div class="canal-row-header-item" style="flex-basis: 40px; padding-top: 4px;" data-cy="treatment-endo-edit-row-dialog-apical-curvature-header">Apical Curvature</div>
        <div style="flex-basis: fit-content; display: flex;" data-cy="treatment-endo-edit-row-dialog-apical-curvature-location-container">
          <div class="canal-list" style="margin-right: 2px; background-color: var(--tdo-background); border-bottom-left-radius: 6px; border-bottom-right-radius: 6px;" data-cy="treatment-endo-edit-row-dialog-apical-curvature-location-1-list">
            @for (enu of enumService.apicalCurv1LocEnums; track enu; let i = $index) {
              <div class="canal-list-item"
                (click)="onItemClick(enu, 'enumEndoApicalCurv1LocID')"
                [ngClass]="{'selected': isSelectedItem(enu, 'enumEndoApicalCurv1LocID')}"
                (contextmenu)="onRightMouseClick($event, enumService.apicalCurv1LocEnums, 'apicalCurv1LocEnums')"
                data-cy="treatment-endo-edit-row-dialog-apical-curvature-location-1-item-{{i}}">
                {{enu.ItemDisplayValue}}
              </div>
            }
          </div>
          <div class="canal-list" style=" background-color: var(--tdo-background); margin-left: 2px; border-bottom-left-radius: 6px; border-bottom-right-radius: 6px;" data-cy="treatment-endo-edit-row-dialog-apical-curvature-location-2-list">
            @for (enu of enumService.apicalCurv2LocEnums; track enu; let i = $index) {
              <div class="canal-list-item"
                (click)="onItemClick(enu, 'enumEndoApicalCurv2LocID')"
                [ngClass]="{'selected': isSelectedItem(enu, 'enumEndoApicalCurv2LocID')}"
                (contextmenu)="onRightMouseClick($event, enumService.apicalCurv2LocEnums, 'apicalCurv2LocEnums')"
                data-cy="treatment-endo-edit-row-dialog-apical-curvature-location-2-item-{{i}}">
                {{enu.ItemDisplayValue}}
              </div>
            }
          </div>
        </div>
        <div style="flex: 1; margin-top: 4px;" data-cy="treatment-endo-edit-row-dialog-apical-curvature-degree-container">
          <div class="canal-list" style=" background-color: var(--tdo-background); height: 100%; border-bottom-left-radius: 6px; border-bottom-right-radius: 6px;" data-cy="treatment-endo-edit-row-dialog-apical-curvature-degree-list">
            @for (enu of enumService.apicalCurvEnums; track enu; let i = $index) {
              <div class="canal-list-item"
                (click)="onItemClick(enu, 'enumEndoApicalCurvID')"
                [ngClass]="{'selected': isSelectedItem(enu, 'enumEndoApicalCurvID')}"
                (contextmenu)="onRightMouseClick($event, enumService.apicalCurvEnums, 'apicalCurvEnums')"
                data-cy="treatment-endo-edit-row-dialog-apical-curvature-degree-item-{{i}}">
                {{enu.ItemDisplayValue}}
              </div>
            }
          </div>
        </div>
      </div>
      <!--    File 2 Bind / Master Apical File-->
      <div class="canal-column" style="background-color: unset; padding-bottom: unset;" data-cy="treatment-endo-edit-row-dialog-file-bind-maf-column">
        <div class="canal-row-header-item" style="padding-top: 4px;" data-cy="treatment-endo-edit-row-dialog-file-bind-header">First File to Bind</div>
        <div class="canal-list" style="background-color: var(--tdo-background); border-bottom-left-radius: 6px; border-bottom-right-radius: 6px;" data-cy="treatment-endo-edit-row-dialog-file-bind-list">
          @for (enu of enumService.firstFile2BindEnums; track enu; let i = $index) {
            <div class="canal-list-item"
              (click)="onItemClick(enu, 'enumEndoFirstFile2BindID')"
              [ngClass]="{'selected': isSelectedItem(enu, 'enumEndoFirstFile2BindID')}"
              (contextmenu)="onRightMouseClick($event, enumService.firstFile2BindEnums, 'firstFile2BindEnums')"
              data-cy="treatment-endo-edit-row-dialog-file-bind-item-{{i}}">
              {{enu.ItemDisplayValue}}
            </div>
          }
        </div>
        <div class="canal-row-header-item" style="margin-top: 4px; padding-top: 4px;" data-cy="treatment-endo-edit-row-dialog-maf-header">Master Apical File</div>
        <div class="canal-list" style="background-color: var(--tdo-background); border-bottom-left-radius: 6px; border-bottom-right-radius: 6px;" data-cy="treatment-endo-edit-row-dialog-maf-list">
          @for (enu of enumService.masterApicalFileEnums; track enu; let i = $index) {
            <div class="canal-list-item"
              (click)="onItemClick(enu, 'enumEndoMasterApicalFileID')"
              [ngClass]="{'selected': isSelectedItem(enu, 'enumEndoMasterApicalFileID')}"
              (contextmenu)="onRightMouseClick($event, enumService.masterApicalFileEnums, 'masterApicalFileEnums')"
              data-cy="treatment-endo-edit-row-dialog-maf-item-{{i}}">
              {{enu.ItemDisplayValue}}
            </div>
          }
        </div>
      </div>
      <!--    Gutta Percha-->
      <div class="canal-column" data-cy="treatment-endo-edit-row-dialog-gutta-percha-column">
        <div class="canal-row-header-item" data-cy="treatment-endo-edit-row-dialog-gutta-percha-header">Gutta Percha</div>
        <div class="canal-list" data-cy="treatment-endo-edit-row-dialog-gutta-percha-list">
          @for (enu of enumService.guttaPerchaEnums; track enu; let i = $index) {
            <div class="canal-list-item"
              (click)="onItemClick(enu, 'enumEndoGuttaPerchaID')"
              [ngClass]="{'selected': isSelectedItem(enu, 'enumEndoGuttaPerchaID')}"
              (contextmenu)="onRightMouseClick($event, enumService.guttaPerchaEnums)"
              data-cy="treatment-endo-edit-row-dialog-gutta-percha-item-{{i}}">
              {{enu.ItemDisplayValue}}
            </div>
          }
        </div>
      </div>
      <!--    Sealer-->
      <div class="canal-column" data-cy="treatment-endo-edit-row-dialog-sealer-column">
        <div class="canal-row-header-item" data-cy="treatment-endo-edit-row-dialog-sealer-header">Sealer</div>
        <div class="canal-list" data-cy="treatment-endo-edit-row-dialog-sealer-list">
          @for (enu of enumService.sealerEnums; track enu; let i = $index) {
            <div class="canal-list-item"
              (click)="onItemClick(enu, 'enumEndoSealerID')"
              [ngClass]="{'selected': isSelectedItem(enu, 'enumEndoSealerID')}"
              (contextmenu)="onRightMouseClick($event, enumService.sealerEnums, 'sealerEnums')"
              data-cy="treatment-endo-edit-row-dialog-sealer-item-{{i}}">
              {{enu.ItemDisplayValue}}
            </div>
          }
        </div>
      </div>
      <!--    Filler / MoO / Sep Removed -->
      <div style="flex: 1; display: flex; flex-direction: column" data-cy="treatment-endo-edit-row-dialog-fill-moo-sep-column">
        <div style="flex-basis: 300px; display: flex;" data-cy="treatment-endo-edit-row-dialog-fill-moo-container">
          <div class="canal-column" data-cy="treatment-endo-edit-row-dialog-fill-column">
            <div class="canal-row-header-item" data-cy="treatment-endo-edit-row-dialog-fill-header">Fill</div>
            <div class="canal-list" data-cy="treatment-endo-edit-row-dialog-fill-list">
              @for (enu of enumService.fillEnums; track enu; let i = $index) {
                <div class="canal-list-item"
                  (click)="onItemClick(enu, 'enumEndoFillID')"
                  [ngClass]="{'selected': isSelectedItem(enu, 'enumEndoFillID')}"
                  (contextmenu)="onRightMouseClick($event, enumService.fillEnums, 'fillEnums')"
                  data-cy="treatment-endo-edit-row-dialog-fill-item-{{i}}">
                  {{enu.ItemDisplayValue}}
                </div>
              }
            </div>
          </div>
          <div class="canal-column" data-cy="treatment-endo-edit-row-dialog-moo-column">
            <div class="canal-row-header-item" data-cy="treatment-endo-edit-row-dialog-moo-header">MoO</div>
            <div class="canal-list" data-cy="treatment-endo-edit-row-dialog-moo-list">
              @for (enu of enumService.methodOfObturationEnums; track enu; let i = $index) {
                <div class="canal-list-item"
                  (click)="onItemClick(enu, 'enumEndoMethodOfObturationID')"
                  [ngClass]="{'selected': isSelectedItem(enu, 'enumEndoMethodOfObturationID')}"
                  (contextmenu)="onRightMouseClick($event, enumService.methodOfObturationEnums, 'methodOfObturationEnums')"
                  data-cy="treatment-endo-edit-row-dialog-moo-item-{{i}}">
                  {{enu.ItemDisplayValue}}
                </div>
              }
            </div>
          </div>
        </div>
        <div class="canal-column" style="margin-top: 4px; flex: 0; flex-basis: 60px;" data-cy="treatment-endo-edit-row-dialog-sep-column">
          <div class="canal-list" data-cy="treatment-endo-edit-row-dialog-sep-list">
            @for (enu of enumService.sepEnums; track enu; let i = $index) {
              <div class="canal-list-item"
                (click)="onItemClick(enu, 'enumEndoSepID')"
                [ngClass]="{'selected': isSelectedItem(enu, 'enumEndoSepID')}"
                (contextmenu)="onRightMouseClick($event, enumService.sepEnums, 'sepEnums')"
                data-cy="treatment-endo-edit-row-dialog-sep-item-{{i}}">
                {{enu.ItemDisplayValue}}
              </div>
            }
          </div>
        </div>
        <!--      TYPE-->
        <div class="enum-select-Tittle" data-cy="treatment-endo-edit-row-dialog-type-label">
          <div style="padding-left: 6px;">Type</div>
          <div style="flex: 1;"></div>
        </div>
        <app-tdo-enum-select zVersion="MTI" class="enum-select" data-cy="treatment-endo-edit-row-dialog-type-select"
          [validValueItemId]="getDropdownValue(fillTypeDropdownModels, 'enumEndoFillTypeID')"
          name="enumEndoFillType"
          (enumSelected)="onDropdownSelected($event, 'enumEndoFillTypeID')">
        </app-tdo-enum-select>
        <!--      BRAND-->
        <div class="enum-select-Tittle">
          <div style="padding-left: 6px;">Brand</div>
          <div style="flex: 1;"></div>
        </div>
        <app-tdo-enum-select  zVersion="MTI" class="enum-select"
          [validValueItemId]="getDropdownValue(fillBrandDropdownModels, 'enumEndoFillBrandID')"
          name="enumEndoFillBrand"
          (enumSelected)="onDropdownSelected($event, 'enumEndoFillBrandID')">
        </app-tdo-enum-select>
        <!--      SIZE-->
        <div class="enum-select-Tittle">
          <div style="padding-left: 6px;">Size</div>
          <div style="flex: 1;"></div>
        </div>
        <app-tdo-enum-select  zVersion="MTI" class="enum-select"
          [validValueItemId]="getDropdownValue(fillSizeDropdownModels, 'enumEndoFillSizeID')"
          name="enumEndoFillSize"
          (enumSelected)="onDropdownSelected($event, 'enumEndoFillSizeID')">
        </app-tdo-enum-select>
        <div class="canal-row-header-item" style="margin-top: 4px;">Location</div>
        <div class="canal-list" style="background-color: var(--tdo-background);">
          @for (enu of enumService.fillLocationEnums; track enu) {
            <div class="canal-list-item" style="font-size: 12px;"
              (click)="onItemClick(enu, 'enumEndoFillLocationID')"
              [ngClass]="{'selected': isSelectedItem(enu, 'enumEndoFillLocationID')}"
              (contextmenu)="onRightMouseClick($event, enumService.fillLocationEnums, 'fillLocationEnums')"
              >
              {{enu.ItemDisplayValue}}
            </div>
          }
        </div>
        <div style="display: flex; margin-top: 4px; background-color: var(--tdo-secondary-accent); border-top-left-radius: 6px; border-top-right-radius: 6px; padding-top: 6px; font-weight: 500;">
          <div style="padding-left: 6px;"># of Uses:</div>
          <div style="flex: 1;"></div>
        </div>
        <input class="canal-dialog-input" type="number" (appInputFinished)="onNumUsesInputFinished($event)" [value]="canalModel.FillNumberOfUses" />
      </div>
      <!--    Inter-Apt-Med-->
      <div class="canal-column">
        <div class="canal-row-header-item" style="padding-top: 4px;">Inter-Apt Med</div>
        <div class="canal-list">
          @for (enu of enumService.interAptMedEnums; track enu) {
            <div class="canal-list-item"
              (click)="onItemClick(enu, 'enumEndoInterAptMedID')"
              [ngClass]="{'selected': isSelectedItem(enu, 'enumEndoInterAptMedID')}"
              (contextmenu)="onRightMouseClick($event, enumService.interAptMedEnums, 'interAptMedEnums')"
              >
              {{enu.ItemDisplayValue}}
            </div>
          }
        </div>
      </div>
      <!--    Estimated Work Length-->
      <div class="canal-column" style="flex: 1;">
        <div class="canal-row-header-item" style="flex-basis: 40px;">Coronal Endo</div>
        <div class="canal-master-list">
          <div class="canal-list" style="overflow-x: hidden; margin-right: 1px;">
            @for (enu of enumService.coronal1TypeEnums; track enu) {
              <div class="canal-list-item"
                (click)="onItemClick(enu, 'enumEndoCoronal1TypeID')"
                [ngClass]="{'selected': isSelectedItem(enu, 'enumEndoCoronal1TypeID')}"
                (contextmenu)="onRightMouseClick($event, enumService.coronal1TypeEnums, 'coronal1TypeEnums')"
                >
                {{enu.ItemDisplayValue}}
              </div>
            }
          </div>
          <div class="canal-list" style="overflow-x: hidden; margin-right: 1px;">
            @for (enu of enumService.coronal2TypeEnums; track enu) {
              <div class="canal-list-item"
                (click)="onItemClick(enu, 'enumEndoCoronal2TypeID')"
                [ngClass]="{'selected': isSelectedItem(enu, 'enumEndoCoronal2TypeID')}"
                (contextmenu)="onRightMouseClick($event, enumService.coronal2TypeEnums, 'coronal2TypeEnums')"
                >
                {{enu.ItemDisplayValue}}
              </div>
            }
          </div>
          <div class="canal-list" style="overflow-x: hidden;">
            @for (enu of enumService.coronalPostSpaceEnums; track enu) {
              <div class="canal-list-item"
                (click)="onItemClick(enu, 'enumEndoCoronalPostSpaceID')"
                [ngClass]="{'selected': isSelectedItem(enu, 'enumEndoCoronalPostSpaceID')}"
                (contextmenu)="onRightMouseClick($event, enumService.coronalPostSpaceEnums, 'coronalPostSpaceEnums')"
                >
                {{enu.ItemDisplayValue}}
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
  <div class="section-footer" style="flex-basis: 50px; min-height: 50px; padding-top: 4px;" data-cy="treatment-endo-edit-row-dialog-footer">
    <div style="flex: 1; margin-right: 6px;"></div>
    <button (click)="onOkClick()" class="tdo-button primary-accent" style="margin-right: 6px;" data-cy="treatment-endo-edit-row-dialog-ok-button">Ok</button>
    <button (click)="onCancelClick()" class="tdo-button primary-accent" style="margin-right: 6px;" data-cy="treatment-endo-edit-row-dialog-cancel-button">Cancel</button>
  </div>


  <ng-template #enumOptionsMenu let-data data-cy="treatment-endo-edit-row-dialog-enum-options-menu">
    <section style="border: 1px solid var(--tdo-secondary);" class="context-menu" data-cy="treatment-endo-edit-row-dialog-context-menu">
      <div (click)="onEditList()" style=" color: black" data-cy="treatment-endo-edit-row-dialog-edit-list-button">Edit List</div>
    </section>


  </ng-template>
</div>


